import { questionTypes } from 'sharedParts';
import { includes } from 'lodash';

const isPostLogicAvailableBlockType = type =>
  includes(
    [
      questionTypes.questionSingle,
      questionTypes.questionScale,
      questionTypes.questionNumeric,
      questionTypes.questionDropdown,
    ],
    type,
  );

export default isPostLogicAvailableBlockType;
